import * as React from "react";
import { observer, inject } from "mobx-react";
import { hashHistory } from "react-router";
import SeekerStore from "../../stores/seekerStore";
import ProfileStore from "../../stores/profileStore";
import { Demographics, Referral } from "../../models/profile";
import { LookupType } from "../../models/enums";
import { sort } from "../../utils/data";
import { LookupValue, RegionReferralSource, RegistrationRegion } from "../../models/lookup";
import { IDemographicsLocalization, IOption } from "../../models/localization";
import { Grid, Row, Col } from "react-flexbox-grid";
import BackButton from "../../components/widgets/backBtn";
import PasswordChangeDlg from "../../components/dialogs/passwordChange";
import Paper from "material-ui/Paper";
import Typography from "material-ui/Typography";
import TextField from "material-ui/TextField";
import Checkbox from "material-ui/Checkbox";
import Select from "material-ui/Select";
import { MenuItem } from "material-ui/Menu";
import { FormControl, FormControlLabel } from "material-ui/Form";
import Input, { InputLabel, InputAdornment } from "material-ui/Input";
import Button from "material-ui/Button";
import * as s from "./demographics.css";

@inject("store") @observer
export default class DemographicsVw extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  componentWillMount() {
    this.props.store.profileStore.initDemographicEdits();
    this.props.store.viewState.trackView();
  }
  componentWillUnmount() {
    this.props.store.profileStore.clearDemographicEdits();
  }
  getRegionSources(demo: Demographics, ndx: number): JSX.Element[] {
    let items: JSX.Element[] = [];
    let region: RegistrationRegion = null;
    if (ndx !== -1) {
      region = this.props.store.localization.regions.find((r: RegistrationRegion): boolean => {
        return r.idHash === demo.referrals[ndx].regionIdHash;
      });
    }
    if (region) {
      region.sources.map((rrs: RegionReferralSource, i: number): void => {
        items.push(<MenuItem key={`regionSrc-${i}`} value={rrs.idHash}>{rrs.name}</MenuItem>);
      });
    }
    return items;
  }
  render(): JSX.Element {
    if (!this.props.store.profileStore.profile) {
      return null;
    }
    const profileStore: ProfileStore = this.props.store.profileStore;
    const demo: Demographics = profileStore.editDemo;
    let ndx: number = -1;
    if (demo.referrals.length === 1) {
      ndx = 0;
    } else {
      demo.referrals.map((r: Referral, i: number): void => {
        if (this.props.store.localization.regions.findIndex((rr: RegistrationRegion): boolean => { return rr.idHash === r.regionIdHash; }) !== -1) {
          ndx = i;
        }
      });
    }
    const local: IDemographicsLocalization = this.props.store.localization.fields.demographics;
    const checked: any = { color: "#5B6770" };

    if (!demo || !local) {
      return null;
    }

    if (demo.eduDist === 100) {
      demo.eduDist = 30;
    }
    return (
      <div>
        <BackButton />
        <Grid className={s.container}>
          <h4 className={s.blueHeader}>{local.aboutMe}</h4>
          <Row>
            <Col xs={12} lg={6} className={s.paperCol}>
              <Paper className={s.box}>
                <h6 className={s.greyHeader}>{local.contactInfo}</h6>
                <Row>
                  <Col xs={12} sm={6} className={s.inputCol} >
                    <TextField fullWidth id="firstName" label={local.firstName} value={demo.firstName || ""} onChange={profileStore.updateDemographics} />
                  </Col>
                  <Col xs={12} sm={6} className={s.inputCol}  >
                    <TextField fullWidth id="lastName" label={local.lastName} value={demo.lastName || ""} onChange={profileStore.updateDemographics} />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={6} className={s.inputCol} >
                    <TextField fullWidth id="emailAddress" disabled={true} label={local.email} value={demo.emailAddress} onChange={profileStore.updateDemographics} />
                  </Col>
                  <Col xs={12} sm={6} className={s.inputCol}>
                    <TextField fullWidth id="phone" label={local.phone} value={demo.phone || ""} onChange={profileStore.updateDemographics} />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} className={s.inputCol}>
                    <Button raised color="secondary" onClick={() => this.props.store.viewState.setShowPasswordChange(true)}>{this.props.store.localization.fields.manage.title}</Button>
                  </Col>
                </Row>
              </Paper>
            </Col>
            <Col xs={12} lg={6} className={s.paperCol}>
              <Paper className={s.box} >
                <h6 className={s.greyHeader}>{local.address}</h6>
                <Row>
                  <Col xs={12} className={s.inputCol}>
                    <TextField fullWidth id="address.street1" label={local.street1} value={demo.address.street1 || ""} onChange={profileStore.updateDemographics} />
                  </Col>
                  <Col xs={12} className={s.inputCol}>
                    <TextField fullWidth id="address.street2" label={local.street2} value={demo.address.street2 || ""} onChange={profileStore.updateDemographics} />
                  </Col>
                  <Col xs={12} sm={6} className={s.inputCol}>
                    <TextField fullWidth id="address.city" label={local.city} value={demo.address.city || ""} onChange={profileStore.updateDemographics} />
                  </Col>
                  <Col xs={12} sm={3} className={s.inputCol}>
                    <TextField fullWidth id="address.state" label={local.state} value={demo.address.state || ""} onChange={profileStore.updateDemographics} />
                  </Col>
                  <Col xs={12} sm={3}>
                    <TextField fullWidth id="address.zip" label={local.zip} value={demo.address.zip || ""} onChange={profileStore.updateDemographics} />
                  </Col>
                </Row>
              </Paper>
            </Col>

            <Col xs={12} lg={6} className={s.paperCol}>
              <Paper className={s.box}>
                <h6 className={s.greyHeader}>{local.demo}</h6>
                <Row>
                  <Col xs={12} sm={6} className={s.inputCol}>
                    <FormControl fullWidth>
                      <InputLabel htmlFor="gender">{local.gender}</InputLabel>
                      <Select
                        name="gender"
                        value={demo.gender || ""}
                        onChange={profileStore.updateDemographics}
                        inputProps={{
                          id: 'gender',
                          name: 'gender',
                        }}>
                        {this.props.store.localization.getLookup(LookupType.Gender).map((d: LookupValue, i: number) => { return (<MenuItem key={"eth-" + i} value={d.order.toString()}>{d.value}</MenuItem>) })}
                      </Select>
                    </FormControl>
                  </Col>
                  <Col xs={12} sm={6} className={s.inputCol}>
                    <FormControl fullWidth>
                      <InputLabel htmlFor="ethnicityId">{local.ethnicity}</InputLabel>
                      <Select
                        name="ethnicityId"
                        value={demo.ethnicityId || ""}
                        onChange={profileStore.updateDemographics}
                        inputProps={{
                          id: 'ethnicityId',
                          name: 'ethnicityId',
                        }}>
                        {this.props.store.localization.getLookup(LookupType.Ethnicity).map((d: LookupValue, i: number) => { return (<MenuItem key={"eth-" + i} value={d.order}>{d.value}</MenuItem>) })}
                      </Select>
                    </FormControl>
                  </Col>
                  <Col xs={12} sm={6} className={s.inputCol}>
                    <FormControl fullWidth>
                      <InputLabel htmlFor="vetStatus">{local.militaryStatus}</InputLabel>
                      <Select
                        name="vetStatus"
                        value={demo.vetStatus || ""}
                        onChange={profileStore.updateDemographics}
                        inputProps={{
                          id: 'vetStatus',
                          name: 'vetStatus',
                        }}>
                        {this.props.store.localization.getLookup(LookupType.VetStatus).map((d: LookupValue, i: number) => { return (<MenuItem key={"vs-" + i} value={d.order}>{d.value}</MenuItem>) })}
                      </Select>
                    </FormControl>
                  </Col>
                  {this.props.store.localization.fields.register.showHowHeard && <Col xs={12} sm={6} >
                    <FormControl fullWidth>
                      <InputLabel htmlFor="howHeard">{this.props.store.localization.fields.register.howHeard}</InputLabel>
                      <Select
                        fullWidth
                        name="howHeard"
                        value={demo.referralId}
                        onChange={profileStore.updateDemographics}
                        inputProps={{
                          id: 'referralId',
                          name: 'referralId',
                        }}>
                        {sort(this.props.store.localization.getLookup(LookupType.HowHeard), "value").map((d: LookupValue, i: number) => {
                          return (<MenuItem key={"howHeard-" + i} value={d.order}>{d.value}</MenuItem>)
                        })}
                      </Select>
                    </FormControl>
                    <br /><br />
                    {demo.referralId === "902" && <div>
                      <TextField label={this.props.store.localization.fields.register.howHeardOther} value={demo.referralSrc} onChange={profileStore.updateDemographics} name="referralSrc" id="referralSrc" /><br /><br />
                    </div>}
                  </Col>}
                  {this.props.store.localization.fields.register.showRegionalSrc && <Col xs={12} sm={6} >
                    <FormControl fullWidth>
                      <InputLabel htmlFor="regionIdHash">{this.props.store.localization.fields.register.region}</InputLabel>
                      <Select fullWidth name="regionIdHash" value={ndx !== -1 ? demo.referrals[ndx].regionIdHash : ""} inputProps={{ id: "regionIdHash", name: "regionIdHash" }} onChange={(e: any) => profileStore.updateDemographicsRegion("regionIdHash", e.target.value, ndx)}>
                        {this.props.store.localization.regions.map((rr: RegistrationRegion, i: number) => {
                          return (<MenuItem key={`region-${i}`} value={rr.idHash}>{rr.name}</MenuItem>)
                        })}
                      </Select>
                    </FormControl>
                    <br /><br />
                    <FormControl fullWidth>
                      <InputLabel htmlFor="sourceIdHash">{this.props.store.localization.fields.register.referralSource}</InputLabel>
                      <Select fullWidth name="sourceIdHash" value={ndx !== -1 ? demo.referrals[ndx].sourceIdHash : ""} inputProps={{ id: "sourceIdHash", name: "sourceIdHash" }} onChange={(e: any) => profileStore.updateDemographicsRegion("sourceIdHash", e.target.value, ndx)}>
                        {this.getRegionSources(demo, ndx)}
                      </Select>
                    </FormControl>
                  </Col>}
                  {this.props.store.localization.fields.register.showHowHeard && <Col xs={12} sm={6} className={s.inputCol}>
                  </Col>}
                  {this.props.store.localization.fields.register.showRegionalSrc && <Col xs={12} sm={6} className={s.inputCol}>
                  </Col>}
                </Row>
              </Paper>
            </Col>
            <Col xs={12} lg={6} className={s.paperCol}>
              <Paper className={s.box} >
                <h6 className={s.greyHeader}>{local.preference}</h6>
                <Row>
                  <Col xs={12} className={s.inputCol}>
                    <FormControlLabel label={local.optIn} control={<Checkbox style={checked} checked={demo.contactFlag} onChange={(e, v) => profileStore.updateDemographicsOptIn(v)} />} />
                  </Col>
                  <Col xs={12} sm={6} className={s.inputCol}>
                    <FormControl fullWidth>
                      <InputLabel htmlFor="eduDist">{local.eduDist}</InputLabel>
                      <Select
                        name="eduDist"
                        value={demo.eduDist || ""}
                        onChange={profileStore.updateDemographics}
                        inputProps={{
                          id: 'eduDist',
                          name: 'eduDist',
                        }}>
                        {local.eduDistOptions.map((d: IOption, i: number) => { return (<MenuItem key={"dist-" + i} value={d.value}>{d.text}</MenuItem>) })}
                      </Select>
                    </FormControl>
                  </Col>
                </Row>
              </Paper>
            </Col>
          </Row>
          <Row>
            <Col xs={12} >
              <div style={{ textAlign: "center", marginBottom: "24px" }}>
                <Button raised color="secondary" style={{ marginRight: "14px" }} disabled={!profileStore.dirty} onClick={profileStore.saveDemographics}>{this.props.store.localization.fields.save}</Button>
                <Button raised color="secondary" disabled={!profileStore.dirty} onClick={profileStore.resetDemographics}>{local.reset}</Button>
              </div>
            </Col>
          </Row>
        </Grid>
        <PasswordChangeDlg store={this.props.store} />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/views/demographics/index.tsx